import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import {dispatchEvent} from "fg-frontend/src/lib/dom";
import $ from "jquery";

class PopupWindow extends WebComponent {

	constructor(props) {
		super(props);
		const {} = props;
		this.state = {};
	}

	didMount () {
		const {
			cookieName,
		} = this.props;

		this.cookieName = cookieName;

		this.checkCookie();

		if(this.element.getAttribute('data-set-cookie') === 'true') {
			if((this.getCookie(this.cookieName) === "1" || this.getCookie(this.cookieName) === "")) {
				this.openPopup();
				this.setCookie(this.cookieName, 0);
			}
		} else {
			this.openPopup();
		}
		if(this.element.getAttribute('data-esp-class-name') === "esp__target--custom-close") {
			$(document).off('keyup.esp').on('keyup.esp', function (event){
				if (event.which == 27) {
					event.preventDefault();
				}
			});
		}
	}

	openPopup = () => {
		let popupWindowData = document.querySelector("#popupWindowData");
		if(popupWindowData) {
			if(popupWindowData.innerText.length > 0){
				dispatchEvent(this.element, 'click', false);
			}
		} else {
			dispatchEvent(this.element, 'click', false);
		}
	}

	setCookie(cName, cValue) {
		document.cookie = cName + "=" + cValue + ";path=/";
	}

	getCookie(cName) {
		var name = cName + "=";
		var ca = document.cookie.split(';');
		for(var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	}

	checkCookie() {
		let name = this.getCookie(this.cookieName);
		if (name === "" && name == null) {
			this.setCookie(this.cookieName, 1);
		}
	}
	willUnMount() {
		this.elements = null;
	}
}

PopupWindow.defaultProps = {
	cookieName: 'showPopUpWindow',
}

export default PopupWindow;



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/PopupWindow.js